var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
// Requires: LayerGroupLayer, LayerGroupRequest
OCS.Viewer.Functions.define_layer_group_single_layer_interface = function () {
    OCS.Viewer.Interfaces.LayerGroupSingleLayer = {
        compute_changes: true,
        init_single_layer_events: function () {
            this.addEvent('map_datetime_obj_added', this.on_single_layer_map_datetime_obj_added.bind(this));
            //this.addEvent('destroy_layer_group', this.destroy_single_layer.bind(this));
        },
        on_single_layer_map_datetime_obj_added: function(dateObj) {
            //dateObj.addEvent('time_update', this.on_single_layer_update.bind(this));
        },
        on_single_layer_update: function (time) {
            var source = this.get_active_layer_source_obj();
            source.set_timestamp_epoch(time);
        },
        should_compute_changes: function (frame) {
            if (frame !== this.current_epoch_time()) {
                this.compute_changes = true;
            } else {
                this.compute_changes = false;
            }
        },

    };
};
OCS.Viewer.Functions.define_layer_group_single_layer_interface();